import iView from 'iview'
import axios from '@/plugins/axios'
export const routerBeforeEach = function (to, from, resolve) {
  axios({
    url: `/user/event/visit`,
    data: {
      origin: 'PC',
      page: to.name
    },
    method: 'GET'
  })
  const token = localStorage.getItem('token')
  if (!token && to.name !== 'login' && to.name !== 'retrieve') {
    resolve({path: '/'})
    return
  }
  const bindPhone = localStorage.getItem('bindPhone')
  if (!token && to.name !== 'login' && to.name !== 'retrieve') {
    if (bindPhone) {
      if (bindPhone == 2 && to.name !== 'bindPhone') {
        resolve({path: '/bindPhone'})
        return
      }
      iView.LoadingBar.start()
      resolve()
      localStorage.removeItem('playToken')
    } else {
      axios({
        url: `/api-ouser/portal/user/getCurrentUser`,
        method: 'GET'
      }).then(({data}) => {
        if (data.data.bindPhone == null) {
          localStorage.setItem('bindPhone', 2)
          resolve({path: '/bindPhone'})
          return
        }
        localStorage.setItem('bindPhone', 1)
        iView.LoadingBar.start()
        resolve()
        localStorage.removeItem('playToken')
      })
    }
  } else {
    iView.LoadingBar.start()
    resolve()
    localStorage.removeItem('playToken')
  }
}
export const routerAfterEach = function (to, from) {
  iView.LoadingBar.finish()
}



// WEBPACK FOOTER //
// ./src/config/interceptors/router/index.js